import { render, staticRenderFns } from "./MainSlider.vue?vue&type=template&id=817760b4&scoped=true&"
import script from "./MainSlider.vue?vue&type=script&lang=ts&"
export * from "./MainSlider.vue?vue&type=script&lang=ts&"
import style0 from "./MainSlider.vue?vue&type=style&index=0&id=817760b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817760b4",
  null
  
)

export default component.exports